<!-- 由 Dioa 创建于 2022-06-23 星期四 -->
<template>
  <div class="report-result">
    <div class="top-user-info">
      <div class="top-basic-info">
        <div class="left-wrapper">
          <div class="user-name"
            >Hi {{ userDetail.truename ? userDetail['truename'] : '' }}</div
          >
          <div class="desc">请查收您的CNA评估报告结果</div>

          <img
            class="wave-line"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1975bfd8eb5cd97610106c3ee418ae.png	"
            alt=""
          />
        </div>

        <!-- <div class="right-wrapper">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-share"
            alt=""
          />
        </div> -->
      </div>
    </div>

    <div class="user-box">
      <div class="user-avatar">
        <img
          :src="
            userDetail['gender'] == '男'
              ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-man-s'
              : userDetail['gender'] == '女'
              ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-women-s'
              : ''
          "
          alt=""
        />
      </div>

      <div class="bottom-user-score">
        <div class="top-text">健康综合得分</div>
        <div class="bottom-detail-wrapper">
          <div class="left-wrapper">
            <span class="current-score">{{ allScore || '0' }}</span>
            <span>/100</span>
          </div>

          <div class="right-wrapper">
            <div class="score-wrapper">
              <span class="dot"></span>
              <span class="score-text">你的得分</span>
            </div>

            <div class="score-wrapper">
              <span class="dot gray"></span>
              <span class="score-text">同龄人平均得分</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="result-charts-box">
      <result-chart ref="resultChart" />
    </div>

    <div class="result-desc-wrapper">
      <div class="main-text">
        <span>你的综合健康水平已超过</span>
        <span class="light-text">{{ contemporary || 0 }}%</span>
        <span>的同龄人</span>
      </div>

      <div class="normal-text" v-if="Object.keys(singleComparison).length">
        <span>你的{{ singleComparison['maxNum']['name'] || '--' }}比</span>
        <span class="light-text"
          >{{ singleComparison['maxNum']['num'] || '0' }}%</span
        >
        <span>的同龄人健康</span>
      </div>

      <div class="normal-text" v-if="Object.keys(singleComparison).length">
        <span>您的{{ singleComparison['minNum']['name'] || '--' }}仅超过</span>
        <span class="light-text"
          >{{ singleComparison['minNum']['num'] || '0' }}%</span
        >
        <span>的同龄人</span>
      </div>
    </div>

    <div class="result-first-target" v-if="fatTargetResult">
      <div class="top-text">您的首要健康目标</div>
      <div class="bottom-desc">
        {{ fatTargetResult }}
      </div>
    </div>

    <div class="result-custom-desc">
      <div class="desc-text"
        >以下是依据您所填写的个人情况，为您量身定制的营养方案</div
      >
    </div>

    <div id="result-tab-wrapper"></div>

    <div class="result-tab-wrapper" :class="{ isFixed: isFixed }">
      <div
        class="tab-item"
        :class="{ currentTab: curretTab == index }"
        v-for="(item, index) in tabList"
        :key="index"
        @click="changeTab(index)"
        >{{ item.label }}</div
      >
    </div>

    <div class="bottom-report-wrapper">
      <div id="result-body-narrative" class="scroll-div"></div>

      <div class="result-body-narrative">
        <div class="top-text">身体简报</div>
        <img
          class="wave-line"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/efddf2c1d64f1a2970c9491bf27662aa.png"
          alt=""
        />
        <div class="detail-wrapper">
          <div class="bmi-wrapper">
            <div class="desc">身体质量指数(BMI)</div>
            <div class="value">{{ score }}</div>
          </div>

          <div class="bmi-progress">
            <template v-for="(item, index) in lineList">
              <div class="line-interval" :key="`interval_${index}`">
                <div
                  class="progress-ball"
                  v-if="item.minScore <= score && score < item.maxScore"
                  :style="{
                    left:
                      Number(
                        fScore(score, item.minScore, item.maxScore) /
                          (item.maxScore - item.minScore)
                      ) *
                        100 +
                      '%'
                  }"
                >
                  <div class="inner-ball"></div>
                </div>
              </div>
              <div
                :key="`line_${index}`"
                class="line"
                :style="{ left: item.lineProgress }"
              >
              </div>

              <div
                :key="`desc_${index}`"
                class="line-desc"
                :style="{ left: item.textProgress }"
                v-html="item.label"
              ></div>
            </template>
          </div>

          <div class="bmi-desc">
            {{ bodyMassResult.msg }}
          </div>

          <!-- <div class="bmi-desc"> 您的减脂变化预测如下图： </div>

          <img class="bmi-image" :src="bodyMassResult.body_url" alt="" /> -->
        </div>
      </div>

      <div class="result-potential-risk">
        <div class="top-text">
          <div class="left-text">
            <div>潜在风险</div>
            <img
              class="wave-line"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/61d832940fafde610c02a5d71e744368.png"
              alt=""
            />
          </div>
          <div class="right-text">
            <span>您存在</span>
            <span class="light-text">{{ healthyList.length }}种</span>
            <span>风险</span>
          </div>
        </div>

        <div class="tab-wrapper">
          <div
            class="tab-item"
            v-for="(item, index) in healthyList"
            :key="index"
            @click="onChangeDiseaseTab(index)"
          >
            <img
              :src="diseaseIndex == index ? item.selected_icon : item.icon"
              class="disease-image"
              alt=""
            />
            <div
              class="disease-name"
              :style="{ color: diseaseIndex == index ? '#373D52' : '#697387' }"
              >{{ item.disease_name }}</div
            >
          </div>
        </div>

        <div class="disease-detail" v-if="healthyList && healthyList.length">
          <div class="top-title">{{
            healthyList[diseaseIndex]['disease_name']
          }}</div>
          <div class="bottom-detail">
            <div class="disease-item">
              <div class="disease-title">可能影响的因素</div>
              <div
                class="disease-desc"
                v-html="healthyList[diseaseIndex]['factor']"
              ></div>
            </div>

            <div class="disease-item">
              <div class="disease-title">营养建议</div>
              <div
                class="disease-desc"
                v-html="healthyList[diseaseIndex]['recommend']"
              ></div>
            </div>
          </div>
        </div>

        <div class="disease-tip"
          >* 以上仅用于提示潜在健康问题，而非当前身体状况的判断</div
        >
      </div>

      <div id="result-dietary-advice" class="scroll-div"></div>

      <div class="result-dietary-advice">
        <div class="top-text">饮食建议</div>
        <img
          class="wave-line"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1975bfd8eb5cd97610106c3ee418ae.png"
          alt=""
        />

        <div class="bottom-detail">
          <div class="box-cover" v-if="eatCollapse"></div>
          <div class="detail-item">
            <div class="detail-title">日常饮食</div>
            <div class="detail-desc">
              <template v-for="(item, index) in advice['dietList']">
                <div
                  v-if="
                    advice && advice['dietList'] && advice['dietList'].length
                  "
                  :key="index"
                  class="detail-desc-item"
                >
                  <div class="detail-desc-title">{{
                    `${index + 1}、${item.title || ''}`
                  }}</div>
                  <div
                    class="detail-desc-content"
                    v-html="item.content || ''"
                  ></div>
                </div>
              </template>
            </div>
          </div>

          <div class="detail-item" v-if="!eatCollapse">
            <div class="detail-title">补充维生素/矿物质</div>
            <div class="detail-extra-info"
              >* 下列
              <span class="light">标有颜色的食物</span>
              为最适合您的超级食物</div
            >
            <div class="detail-desc">
              <template v-for="(item, index) in advice['vitaminList']">
                <div
                  v-if="
                    advice &&
                    advice['vitaminList'] &&
                    advice['vitaminList'].length
                  "
                  :key="index"
                  class="detail-desc-item"
                >
                  <div class="detail-desc-title">{{
                    `${index + 1}、${item.title || ''}`
                  }}</div>
                  <div
                    class="detail-desc-content"
                    v-html="item.content || ''"
                  ></div>
                </div>
              </template>
            </div>
          </div>

          <div class="detail-item" v-if="!eatCollapse">
            <div class="detail-title">
              <span
                class="iconfont icon-weixianyuan"
                style="color: #eb6b83"
              ></span
              >减少摄入</div
            >
            <div class="detail-desc">
              <template v-for="(item, index) in advice['ingestionList']">
                <div
                  v-if="
                    advice &&
                    advice['ingestionList'] &&
                    advice['ingestionList'].length
                  "
                  :key="index"
                  class="detail-desc-item"
                >
                  <div class="detail-desc-title">{{
                    `${index + 1}、${item.title || ''}`
                  }}</div>
                  <div
                    class="detail-desc-content"
                    v-html="item.content || ''"
                  ></div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="collapse-text" @click="eatCollapse = !eatCollapse">{{
          eatCollapse ? '展开' : '收起'
        }}</div>
      </div>

      <div class="result-small-target">
        <div class="top-text">每日小目标</div>
        <img
          class="wave-line"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/efddf2c1d64f1a2970c9491bf27662aa.png"
          alt=""
        />

        <div class="bottom-detail">
          <div
            class="detail-item"
            v-for="(item, index) in daily_tip"
            :key="index"
            :style="fTargetColor('bg', index)"
          >
            <div class="top-text-wrapper">
              <span class="top-text-number">{{ index + 1 }}</span>
              <span class="top-title">{{ item.title }}</span>
            </div>

            <div class="bottom-detail-wrapper">{{ item.content }}</div>

            <img :src="item.icon_url" class="target-desc-image" alt="" />

            <div class="target-ball" :style="fTargetColor('ball', index)"></div>
          </div>
        </div>
      </div>

      <div id="result-meal-plan" class="scroll-div"></div>

      <div class="result-meal-plan" v-if="!isOriginal">
        <div class="top-text">营养全餐方案</div>
        <img
          class="wave-line"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f1975bfd8eb5cd97610106c3ee418ae.png"
          alt=""
        />

        <img
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-yyfa"
          alt=""
          class="food-no-image"
          v-if="isShowNoFoodImage"
        />

        <template v-else>
          <div class="bottom-detail-wrapper">
            <div class="top-plan-tab">
              <div
                class="top-plan-tab-item"
                v-for="(item, index) in planTab"
                :key="index"
                @click="currentPlanIndex = index"
                :class="{ currentPlan: currentPlanIndex == index }"
              >
                <img :src="item.image" alt="" />
                <div>{{ item.title }}</div>
              </div>
            </div>

            <div class="bottom-plan-detail">
              <div class="top-day-tab">
                <div
                  class="top-day-tab-item"
                  v-for="(item, index) in dayTab"
                  :key="index"
                  @click="currentDayIndex = index"
                  :class="{ currentDayTab: currentDayIndex == index }"
                  >{{ item }}</div
                >
              </div>

              <div class="bottom-day-food-list">
                <div
                  class="bottom-play-list-item"
                  v-for="(item, index) in foodPlanList"
                  :key="index"
                >
                  <div class="top-info">
                    <div class="top-title">{{ item.label }}</div>
                    <div class="top-time">{{ item.time }}</div>
                  </div>
                  <div class="bottom-food-list">
                    <div
                      class="bottom-food-list-item"
                      v-for="(foodItem, foodIndex) in item.foodList"
                      :key="foodIndex"
                    >
                      <template v-if="foodItem.foodName.length == 1">
                        <div class="food-type">{{ foodItem.type }}</div>
                        <div class="food-foodName">
                          <div
                            class="food-foodName-item"
                            v-for="(
                              foodName, foodNameIndex
                            ) in foodItem.foodName"
                            :key="foodNameIndex"
                            >{{ foodName }}</div
                          >
                        </div>
                        <div class="food-line"></div>
                        <div class="food-much">{{ foodItem.much }}</div>
                      </template>

                      <template v-else>
                        <div class="food-type">{{ foodItem.type }}</div>
                        <div class="food-foodName">
                          <div class="food-more-line"></div>
                          <div
                            class="food-more-foodName-item"
                            v-for="(
                              foodName, foodNameIndex
                            ) in foodItem.foodName"
                            :key="foodNameIndex"
                            >{{ foodName }}</div
                          >
                        </div>

                        <div class="food-more-link-line-wrapper">
                          <div class="food-more-link-line"> </div>
                        </div>
                        <div class="food-more-much-wrapper">
                          <div class="food-more-much">{{ foodItem.much }}</div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div
                    class="recommond-food"
                    v-if="item.recommend_meal && item.recommend_meal.length"
                  >
                    <span>推荐菜:</span>
                    <span> {{ item.recommend_meal.join('、') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="meal-plan-tips"
            >* 本食谱所有克数代表生重，一掌一拳代表熟重</div
          >
        </template>
      </div>

      <!-- <div class="result-weight-manager" v-if="!isOriginal">
        <div class="bottom-info-wrapper" @click="imageShow = true">
          <img
            class="info-avatar"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-yy"
            alt=""
          />
          <div class="info-desc">
            更多健康状况和减脂建议 <br />
            营养师助教橘子告诉你～
          </div>
          <van-icon name="arrow" />
        </div>
      </div> -->
    </div>

    <div id="result-bottom-image" class="scroll-div"></div>

    <img
      class="result-bottom-image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/670002d9878f25f67d448cce72a696b2.png"
      alt=""
    />

    <!-- <div class="bottom-logo">
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
    </div> -->

    <image-pop
      :visible.sync="imageShow"
      imageUrl="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-qrcode"
    />
  </div>
</template>

<script>
import { lineList } from './mock'

import * as _ from 'lodash'

import resultChart from './ponents/result-chart.vue'

import imagePop from './ponents/image-pop.vue'

export default {
  name: 'report-result',

  components: {
    resultChart,
    imagePop
  },

  props: {},

  data() {
    return {
      allScore: '', // 综合得分
      contemporary: '', // 健康水平
      singleComparison: {}, // 单项比较
      fatTargetResult: '', // 首要减脂目标

      bodyMassResult: {}, // 身体质量指数

      advice: {}, // 饮食建议
      daily_tip: [], // 每日小目标

      diseaseIndex: 0, // 选中的疾病
      healthyList: [], // 潜在风险

      userDetail: {}, // 用户信息

      curretTab: 0,

      lineList,

      score: 0, // 用户分数
      scoreMax: 35, // 总分数
      scoreMin: 16, // 起点分数

      mealList: [], // 营养全餐方案
      isShowNoFoodImage: false, // 是否显示无全餐方案图片
      isOriginal: true, // 是否是正价营

      isFixed: false,

      currentPlanIndex: 0,
      currentDayIndex: 0,

      imageShow: false,

      eatCollapse: false
    }
  },

  computed: {
    tabList() {
      let tabArr = []
      if (this.isOriginal) {
        tabArr = [
          {
            id: 'healthReport',
            label: '健康报告'
          },
          {
            id: 'nutrientSolution',
            label: '饮食建议'
          },
          {
            id: 'betterweReduced',
            label: 'betterWE减脂营'
          }
        ]
      } else {
        tabArr = [
          {
            id: 'healthReport',
            label: '健康报告'
          },
          {
            id: 'nutrientSolution',
            label: '营养方案'
          },
          {
            id: 'betterweReduced',
            label: 'betterWE减脂营'
          }
        ]
      }
      return tabArr
    },
    planTab() {
      if (!this.mealList.length) return []
      let tabList = this.mealList.map((item) => {
        return {
          title: item.title,
          image: item.image
        }
      })
      return tabList
    },
    dayTab() {
      if (
        this.mealList.length &&
        this.mealList[this.currentPlanIndex]?.detailPlanList &&
        this.mealList[this.currentPlanIndex]?.detailPlanList.length
      ) {
        let saveList = this.mealList[this.currentPlanIndex].detailPlanList.map(
          (item) => item.label
        )
        return saveList
      }
      return []
    },
    foodPlanList() {
      if (
        this.mealList.length &&
        this.mealList[this.currentPlanIndex]?.detailPlanList &&
        this.mealList[this.currentPlanIndex]?.detailPlanList.length &&
        this.mealList[this.currentPlanIndex]?.detailPlanList[
          this.currentDayIndex
        ]['planList'] &&
        this.mealList[this.currentPlanIndex]?.detailPlanList[
          this.currentDayIndex
        ]['planList'].length
      ) {
        return this.mealList[this.currentPlanIndex].detailPlanList[
          this.currentDayIndex
        ]['planList']
      }
      return []
    }
  },

  watch: {},

  created() {},

  mounted() {
    this.loadData()
    this.listenScroll()
  },

  destroyed() {},

  methods: {
    // 分数转换
    fScore(score, minScore, maxScore) {
      if (score == minScore) {
        return 0
      }

      if (score == maxScore) {
        return maxScore - minScore
      }

      return Number(score - minScore)
    },
    // 获取数据
    async loadData() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      try {
        let res = await this.$http.getBaseApp('member/AppCamp/getCNAScheme', {
          rid: this.$route.query.rid
        })

        let { code, data } = res?.data?.data
        if (code == 1) {
          this.$toast.clear()
          // 基本数据
          this.allScore = data?.radarResult?.allScore || ''

          // 雷达图
          let indicatorList = ['运动', '饮食', '体质', '情绪', '习惯', '睡眠']
          let yourScore = []
          let averageScore = []
          indicatorList.forEach((item) => {
            let scoreArr = data?.radarResult?.data.filter(
              (actItem) => actItem.name == item
            )
            yourScore.push(scoreArr[0].score)
          })

          indicatorList.forEach((item) => {
            let scoreArr = data?.radarResult?.averageData.filter(
              (actItem) => actItem.name == item
            )
            averageScore.push(scoreArr[0].score)
          })
          this.$refs.resultChart.initChart(yourScore, averageScore)

          // 健康水平
          this.contemporary = data?.radarResult?.contemporary || ''

          // 单项比较
          this.singleComparison = data?.radarResult?.singleComparison || {}

          // 首要减脂目标
          this.fatTargetResult = data?.fatTargetResult || ''

          // 身体质量指数
          this.bodyMassResult = data?.bodyMassResult || {}

          if (
            data?.bodyMassResult?.bmi >= this.scoreMin &&
            data?.bodyMassResult?.bmi <= this.scoreMax
          ) {
            this.score = data?.bodyMassResult?.bmi
              ? data?.bodyMassResult?.bmi
              : 0
          } else if (data?.bodyMassResult?.bmi < this.scoreMin) {
            this.score = this.scoreMin
          } else if (data?.bodyMassResult?.bmi > this.scoreMax) {
            this.score = this.scoreMax
          }

          // 饮食建议
          this.advice = data?.adviceList?.advice || {}

          // 每日小目标
          this.daily_tip = data?.adviceList?.daily_tip || []

          // 潜在风险
          this.healthyList = data?.healthyList || []

          // 用户信息
          this.userDetail = data?.userDetail || {}

          // 全餐方案
          // 1-正常 0-不显示/正价营 -1-显示图片
          if (data?.mealList?.type == 1) {
            this.mealList = data?.mealList?.data || []
            this.isOriginal = false
            this.isShowNoFoodImage = false
          } else if (data?.mealList?.type == 0) {
            this.isOriginal = true
          } else if (data?.mealList?.type == -1) {
            this.isOriginal = false
            this.isShowNoFoodImage = true
          }

          if (data?.mealList?.is_self_control) {
            this.currentPlanIndex = 0
          } else {
            this.currentPlanIndex = 1
          }
        } else {
          this.$toast.clear()
          this.$toast.fail({
            message: res?.data?.data?.msg
          })
        }
      } catch (err) {
        this.$toast.clear()
      }
    },
    // 切换tab
    changeTab(index) {
      this.curretTab = index
      let domId = ''
      if (index == 0) {
        domId = '#result-body-narrative'
      } else if (index == 1) {
        domId = this.isOriginal ? '#result-dietary-advice' : '#result-meal-plan'
      } else {
        domId = '#result-bottom-image'
      }
      document.querySelector(domId).scrollIntoView()
    },
    // 切换疾病tab
    onChangeDiseaseTab(index) {
      this.diseaseIndex = index
    },
    // 小目标背景色
    fTargetColor(type = 'bg', index) {
      let bgcolorArr = ['#E9F6FC', '#EAF6F3', '#F1EFFB']
      let ballColorArr = ['#B1E5FC', '#B5E4D2', '#D1C5FE']
      let styleObj = {}
      if (type == 'bg') {
        styleObj = {
          backgroundColor: bgcolorArr[index]
        }
      } else if (type == 'ball') {
        styleObj = {
          backgroundColor: ballColorArr[index]
        }
      }
      return styleObj
    },
    // 监听滚动事件
    listenScroll() {
      window.addEventListener('scroll', _.throttle(this.calcHeight, 200))
    },
    calcHeight() {
      let secondDomHeight = document.querySelector(
        this.isOriginal ? '#result-dietary-advice' : '#result-meal-plan'
      ).offsetTop

      let thirdDomHeight = document.querySelector(
        '#result-bottom-image'
      ).offsetTop

      let tabHeight = document.querySelector('#result-tab-wrapper').offsetTop

      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop

      if (scrollTop < tabHeight) {
        this.isFixed = false
      } else {
        this.isFixed = true
      }

      if (scrollTop >= thirdDomHeight - 10) {
        this.curretTab = 2
      } else if (
        scrollTop >= secondDomHeight - 10 &&
        scrollTop < thirdDomHeight - 10
      ) {
        this.curretTab = 1
      } else {
        this.curretTab = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.report-result {
  background-color: #fbfbfb;
  min-height: 100vh;

  .top-user-info {
    height: vw(170);
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-topbg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: vw(17) vw(31);
    box-sizing: border-box;
    .wave-line {
      width: vw(32);
      margin-top: vw(9);
    }
    .top-basic-info {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .left-wrapper {
        .user-name {
          font-size: vw(31);
          font-weight: 500;
          color: #ffffff;
          line-height: vw(39);
        }
        .desc {
          font-size: vw(15);
          font-weight: 500;
          color: #ffffff;
          line-height: vw(21);
          position: relative;
        }
      }
      .right-wrapper {
        img {
          width: vw(70);
        }
      }
    }
  }

  .user-box {
    background-color: #fff;
    box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
    border-radius: vw(12);
    height: vw(110);
    margin: vw(-55) vw(20) 0;
    position: relative;
    box-sizing: border-box;
    .user-avatar {
      position: absolute;
      width: vw(62);
      height: vw(62);
      border-radius: 50%;
      left: 50%;
      top: -50%;
      transform: translate(-50%, 50%);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom-user-score {
      padding: vw(37) vw(40) vw(18) vw(46);
      .top-text {
        font-size: vw(12);
        font-weight: 500;
        color: #363d54;
        line-height: vw(17);
      }
      .bottom-detail-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        &::after {
          position: absolute;
          content: '';
          left: 50%;
          top: 50%;
          transform: translate(-100%, -50%);
          height: vw(35.8);
          border-right: 1px solid #e4e4e4;
          border-top: 1px solid transparent;
          border-bottom: 1px solid transparent;
        }

        .left-wrapper {
          font-size: 15px;
          font-weight: bold;
          color: #363d54;
          line-height: vw(18);
          position: relative;

          .current-score {
            font-size: 40px;
            font-weight: bold;
            color: #363d54;
            line-height: vw(49);
            display: inline-block;
            margin-right: vw(5);
          }
        }

        .right-wrapper {
          box-sizing: border-box;
          .score-wrapper {
            display: flex;
            align-items: center;
            margin-bottom: vw(7);
            &:last-child {
              margin-bottom: 0;
            }
          }
          .dot {
            display: inline-block;
            position: relative;
            height: 0;
            width: 0;
            border-left: vw(6) solid transparent;
            border-right: vw(6) solid transparent;
            border-bottom: vw(5) solid #6759ff;
            top: vw(-4);
            &.gray {
              border-left: vw(6) solid transparent;
              border-right: vw(6) solid transparent;
              border-bottom: vw(5) solid #e2e3ea;
              &::before {
                content: '';
                position: absolute;
                top: vw(5);
                left: vw(-6);
                width: vw(7);
                border-width: vw(6) vw(2) 0 vw(2);
                border-style: solid;
                border-color: #e2e3ea transparent transparent transparent;
              }
            }
            &::before {
              content: '';
              position: absolute;
              top: vw(5);
              left: vw(-6);
              width: vw(7);
              border-width: vw(6) vw(2) 0 vw(2);
              border-style: solid;
              border-color: #6759ff transparent transparent transparent;
            }
          }
          .score-text {
            font-size: vw(12);
            font-weight: 500;
            color: #363d54;
            line-height: vw(17);
            display: inline-block;
            margin-left: vw(9);
          }
        }
      }
    }
  }

  .result-charts-box {
    margin-top: vw(30);
    padding: 0 vw(20);
  }

  .result-desc-wrapper {
    margin-top: vw(26);
    padding: 0 vw(20);
    .main-text {
      font-size: vw(16);
      font-weight: bold;
      color: #373d52;
      line-height: vw(22);
      margin-bottom: vw(3);
      .light-text {
        display: inline-block;
        margin: 0 vw(5);
        font-size: vw(19);
        font-weight: bold;
        color: #6759ff;
        line-height: vw(23);
      }
    }
    .normal-text {
      font-size: vw(12);
      font-weight: 500;
      color: #697387;
      line-height: vw(21);
      .light-text {
        display: inline-block;
        margin: 0 vw(5);
        color: #897ffc;
        font-size: vw(14);
        font-weight: bold;
      }
    }
  }

  .result-first-target {
    margin-top: vw(20);
    padding: 0 vw(20);
    .top-text {
      font-size: vw(16);
      font-weight: 500;
      color: #373d52;
      line-height: vw(21);
    }
    .bottom-desc {
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-res-tg-bg?v=3');
      background-size: cover;
      background-position: center;
      height: vw(50);
      box-sizing: border-box;
      padding-top: vw(20);
      padding-left: vw(20);
      font-size: vw(16);
      font-weight: 600;
      color: #6759ff;
    }
  }

  .result-custom-desc {
    position: relative;
    height: vw(1);
    background-color: #dddddd;
    margin: vw(20) vw(20) vw(10);
    box-sizing: border-box;
    .desc-text {
      font-size: vw(10);
      font-weight: 400;
      color: rgba(#7e8296, 0.7);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: #fbfbfb;
      white-space: nowrap;
      padding: vw(0) vw(9);
    }
  }

  .result-tab-wrapper {
    display: flex;
    justify-content: space-between;
    padding: vw(20) vw(20) vw(21);
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fbfbfb;
    z-index: 999;
    box-sizing: border-box;
    &.isFixed {
      box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
    }
    .tab-item {
      padding: vw(7) vw(17);
      background: #f4f4f4;
      border-radius: vw(8);
      font-size: vw(14);
      font-weight: 400;
      color: #363d54;
    }
    .currentTab {
      background: #6759ff;
      color: #ffffff;
    }
  }

  .bottom-report-wrapper {
    padding: 0 vw(20);

    .wave-line {
      width: vw(32);
    }

    .result-body-narrative {
      padding: vw(26) vw(21);
      background-color: #fff;
      box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
      border-radius: vw(12);
      margin-bottom: vw(20);
      .top-text {
        font-size: vw(22);
        font-weight: normal;
        color: #373d52;
        position: relative;
        font-weight: bold;
      }
      .detail-wrapper {
        background: rgba(#f4f6fa, 0.93);
        border-radius: vw(12);
        padding: vw(16);
        margin-top: vw(20);
      }
      .bmi-wrapper {
        font-size: vw(15);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #373d52;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: vw(27);
      }
      .bmi-progress {
        margin-bottom: vw(60);
        height: vw(7);
        background: linear-gradient(
          90deg,
          #fc6182 0%,
          #897ffc 26%,
          #897ffc 75%,
          #fd6181 100%
        );
        border-radius: vw(12);
        position: relative;
        display: flex;
        .line-interval {
          flex: 1;
          position: relative;
        }
        .line {
          position: absolute;
          top: 0;
          bottom: 0;
          width: vw(1);
          background-color: #fff;
        }
        .line-desc {
          position: absolute;
          top: calc(100% + 2.67vw);
          font-size: vw(12);
          font-weight: 400;
          color: #697387;
          text-align: center;
        }
        .progress-ball {
          position: absolute;
          width: vw(11);
          height: vw(11);
          border-radius: 50%;
          padding: vw(2);
          box-sizing: border-box;
          background-color: #897ffc;
          overflow: hidden;
          top: 50%;
          transform: translate(calc(-50% - 1px), -50%);
          z-index: 10;
          .inner-ball {
            width: 100%;
            height: 100%;
            background-color: #fff;
            border-radius: 50%;
          }
        }
      }
      .bmi-desc {
        font-size: vw(12);
        font-weight: 400;
        color: #697387;
        line-height: vw(20);
      }
      .bmi-image {
        width: 100%;
        height: auto;
      }
    }

    .result-potential-risk {
      padding: vw(26) vw(21);
      background-color: #fff;
      box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
      border-radius: vw(12);
      margin-bottom: vw(20);
      .top-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: vw(20);
        .left-text {
          font-size: vw(22);
          font-weight: normal;
          color: #363d54;
          position: relative;
          font-weight: bold;
        }
        .right-text {
          font-size: vw(12);
          font-weight: 400;
          color: #373d52;
          margin-bottom: vw(5);
          .light-text {
            color: #fd6181;
          }
        }
      }

      .tab-wrapper {
        display: flex;
        width: 100%;
        overflow-x: auto;
        .tab-item {
          margin-right: vw(24);
          &:last-child {
            margin-right: 0;
          }
          .disease-image {
            width: vw(72);
            height: vw(72);
            border-radius: vw(12);
            object-fit: cover;
          }
          .disease-name {
            font-size: vw(12);
            font-weight: 600;
            color: #697387;
            margin-top: vw(10);
            text-align: center;
          }
        }
      }

      .disease-detail {
        margin-top: vw(30);
        display: flex;
        align-items: center;
        flex-direction: column;
        .top-title {
          text-align: center;
          font-size: vw(22);
          font-weight: normal;
          color: #363d54;
          position: relative;
          display: inline;
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: calc(100% + 2.67vw);
            width: vw(31);
            height: vw(1);
            background-color: #dddddd;
          }

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: calc(100% + 2.67vw);
            width: vw(31);
            height: vw(1);
            background-color: #dddddd;
          }
        }
        .bottom-detail {
          background: #f5f7fb;
          border-radius: vw(12);
          padding: vw(16);
          margin-top: vw(20);
          .disease-item {
            margin-bottom: vw(20);
            &:last-child {
              margin-bottom: 0;
            }
            .disease-title {
              font-size: vw(15);
              font-weight: 600;
              color: #373d52;
              margin-bottom: vw(16);
            }
            .disease-desc {
              font-size: vw(12);
              font-weight: 400;
              color: #697387;
              line-height: vw(20);
            }
          }
        }
      }

      .disease-tip {
        font-size: vw(10);
        font-weight: 400;
        color: #7e8296;
        text-align: center;
        margin-top: vw(12);
      }
    }

    .result-dietary-advice {
      padding: vw(26) vw(21);
      background-color: #fff;
      box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
      border-radius: vw(12);
      margin-bottom: vw(20);
      .top-text {
        font-size: vw(22);
        font-weight: normal;
        color: #373d52;
        position: relative;
        font-weight: bold;
      }
      .bottom-detail {
        margin-top: vw(20);
        background: rgba(#f4f6fa, 0.93);
        border-radius: vw(12);
        padding: vw(16);
        position: relative;
        .detail-item {
          margin-bottom: vw(30);
          &:last-child {
            margin-bottom: 0;
          }
          .detail-title {
            font-size: vw(15);
            font-weight: 600;
            color: #373d52;
            margin-bottom: vw(16);
            .icon-weixianyuan {
              font-size: vw(14);
              margin-right: vw(6);
            }
          }
          .detail-extra-info {
            font-size: vw(10);
            font-weight: 400;
            color: #373d52;
            margin-top: vw(-10);
            margin-bottom: vw(14);
            .light {
              color: #6759ff;
              font-weight: bold;
            }
          }
          .detail-desc {
            font-size: vw(12);
            font-weight: 500;
            color: #697387;
            line-height: vw(20);
            .detail-desc-item {
              margin-bottom: vw(16);
              .detail-desc-title {
                font-weight: bolder;
              }
              .detail-desc-content {
                font-weight: normal;
              }
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .box-cover {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            180deg,
            rgba(253, 253, 253, 0) 0%,
            #fbfbfb 100%
          );
          height: vw(100);
        }
      }

      .collapse-text {
        font-size: vw(13);
        font-weight: 500;
        color: #373d52;
        text-align: center;
        margin-top: vw(10);
        text-decoration: underline;
      }
    }

    .result-small-target {
      padding: vw(26) vw(21);
      background-color: #fff;
      box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
      border-radius: vw(12);
      margin-bottom: vw(20);
      .top-text {
        font-size: vw(22);
        font-weight: normal;
        color: #373d52;
        position: relative;
        font-weight: bold;
      }

      .bottom-detail {
        margin-top: vw(20);
        .detail-item {
          padding: vw(16);
          margin-bottom: vw(20);
          position: relative;
          border-radius: vw(12);
          &:last-child {
            margin-bottom: 0;
          }
          .top-text-wrapper {
            display: flex;
            align-items: center;
            margin-bottom: vw(16);
            .top-text-number {
              font-size: vw(18);
              font-weight: 900;
              color: #373d52;
              display: inline-block;
              margin-right: vw(6);
            }
            .top-title {
              font-size: vw(15);
              font-weight: 600;
              color: #373d52;
            }
          }

          .bottom-detail-wrapper {
            font-size: vw(12);
            font-weight: 400;
            color: #697387;
            line-height: vw(20);
          }

          .target-desc-image {
            position: absolute;
            width: vw(49);
            height: vw(49);
            object-fit: cover;
            right: vw(17);
            top: vw(-12);
            z-index: 2;
          }

          .target-ball {
            position: absolute;
            width: vw(31);
            height: vw(31);
            border-radius: 50%;
            top: vw(6);
            right: vw(16);
          }
        }
      }
    }

    .result-meal-plan {
      padding: vw(26) vw(21);
      background-color: #fff;
      box-shadow: 0px vw(5) vw(11) 0px rgba(0, 0, 0, 0.03);
      border-radius: vw(12);
      margin-bottom: vw(20);
      .top-text {
        font-size: vw(22);
        font-weight: normal;
        color: #373d52;
        position: relative;
        font-weight: bold;
      }
      .food-no-image {
        width: vw(204);
        margin: vw(41) auto 0;
      }
      .bottom-detail-wrapper {
        margin-top: vw(20);
        border-radius: vw(12);
        background-color: #f5f7fb;
        overflow: hidden;

        .top-plan-tab {
          display: flex;
          > div {
            flex: 1;
            background-color: #d4d5dd;
            color: #fff;
          }
          .top-plan-tab-item {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: vw(8) 0;
            &.currentPlan {
              background-color: #9890fd;
              position: relative;
            }
            img {
              width: vw(16);
              height: vw(16);
              object-fit: cover;
              margin-right: vw(6);
            }
            div {
              font-size: vw(15);
              font-weight: 600;
              color: #ffffff;
            }
          }
        }
        .bottom-plan-detail {
          padding: vw(21) vw(16);
          .top-day-tab {
            display: flex;
            align-items: center;
            overflow-x: auto;
            width: 100%;
            .top-day-tab-item {
              padding: vw(5) vw(0);
              background-color: #edeff3;
              font-size: vw(13);
              font-weight: 400;
              color: #697387;
              border-right: 1px solid #f5f7fb;
              flex: 0 0 vw(80);
              box-sizing: border-box;
              display: flex;
              justify-content: center;
              &.currentDayTab {
                background: #ffffff;
                box-shadow: 0px vw(4) vw(7) 0px rgba(0, 0, 0, 0.03);
                border-radius: vw(6);
                font-weight: 600;
                color: #6759ff;
              }
              &:first-child {
                border-top-left-radius: vw(6);
                border-bottom-left-radius: vw(6);
              }

              &:last-child {
                border-top-right-radius: vw(6);
                border-bottom-right-radius: vw(6);
                border-right: none;
              }
            }
          }

          .bottom-day-food-list {
            margin-top: vw(20);
            .bottom-play-list-item {
              margin-bottom: vw(20);
              &:last-child {
                margin-bottom: 0;
              }
              .top-info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: vw(10);
                .top-title {
                  font-size: vw(15);
                  font-weight: 600;
                  color: #373d52;
                }
                .top-time {
                  font-size: vw(15);
                  font-weight: 500;
                  color: #697387;
                }
              }

              .bottom-food-list {
                .bottom-food-list-item {
                  display: flex;
                  margin-bottom: vw(10);
                  &:last-child {
                    margin-bottom: 0;
                  }
                  .food-type {
                    font-size: vw(10);
                    font-weight: 400;
                    color: #697387;
                    flex: 0 0 vw(50);
                    margin-right: vw(7);
                  }
                  .food-foodName {
                    font-size: vw(12);
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #697387;
                    position: relative;
                    .food-more-foodName-item {
                      margin-bottom: vw(10);
                      max-width: vw(104);
                      word-break: break-all;
                      &:last-child {
                        margin-bottom: 0;
                      }
                    }

                    .food-foodName-item {
                      max-width: vw(104);
                      word-break: break-all;
                    }

                    .food-more-line {
                      position: absolute;
                      top: vw(5);
                      bottom: vw(5);
                      left: calc(100% + 2.66666vw);
                      width: vw(32);
                      border-top-right-radius: vw(30);
                      border-bottom-right-radius: vw(30);
                      border: 1px dashed #c0c2d0;
                      border-left: none;
                      background-color: #f5f7fb;
                    }
                  }
                  .food-line {
                    margin: vw(8) vw(13) 0 vw(16);
                    flex: 1;
                    height: 0;
                    border-top: 1px dashed #c0c2d0;
                    border-left: 1px dashed transparent;
                    border-right: 1px dashed transparent;
                  }
                  .food-more-link-line-wrapper {
                    flex: 1;
                    margin-left: vw(5) + 2.66666vw;
                    display: flex;
                    align-items: center;
                    .food-more-link-line {
                      margin: 0 vw(13) 0 vw(0);
                      height: 0px;
                      overflow: hidden;
                      width: 100%;
                      border-top: 1px dashed #c0c2d0;
                      border-left: 1px dashed transparent;
                      border-right: 1px dashed transparent;
                    }
                  }

                  .food-much {
                    padding: vw(0) vw(12);
                    height: vw(20);
                    line-height: vw(20);
                    border-radius: vw(9);
                    background-color: #edeff3;
                    font-size: vw(10);
                    font-weight: 400;
                    color: #697387;
                    word-break: break-all;
                    white-space: nowrap;
                  }

                  .food-more-much-wrapper {
                    display: flex;
                    align-items: center;
                    .food-more-much {
                      padding: vw(0) vw(12);
                      height: vw(20);
                      line-height: vw(20);
                      border-radius: vw(9);
                      background-color: #edeff3;
                      font-size: vw(10);
                      font-weight: 400;
                      color: #697387;
                      word-break: break-all;
                      white-space: nowrap;
                    }
                  }
                }
              }

              .recommond-food {
                font-size: vw(10);
                font-weight: 400;
                color: #6759ff;
                margin-top: vw(10);
                line-height: vw(20);
                > span {
                  &:last-child {
                    color: #697387;
                  }
                }
              }
            }
          }
        }
      }
      .meal-plan-tips {
        font-size: vw(10);
        font-weight: 400;
        color: #7e8296;
        margin-top: vw(12);
        margin-left: vw(16);
      }
    }

    .result-weight-manager {
      background: #fff3e8;
      border-radius: vw(12);
      padding: vw(26) vw(22) vw(23);
      .top-text {
        font-size: vw(16);
        font-weight: normal;
        color: #363d54;
        margin-bottom: vw(20);
      }
      .weight-plan-pro {
        font-size: vw(22);
        font-weight: normal;
        color: #363d54;
        position: relative;
        z-index: 1;
        margin-bottom: vw(11);
        &::after {
          position: absolute;
          content: '';
          height: vw(7);
          left: 0;
          right: 0;
          bottom: vw(2);
          background-color: rgba(#fb9b9b, 0.81);
          z-index: -1;
        }
      }
      .weight-plan-desc {
        font-size: vw(15);
        font-weight: 400;
        color: #373d52;
      }
      .weight-line {
        width: 100%;
        height: vw(1);
        background-color: rgba(#373d52, 0.12);
        // margin: vw(20) 0;
      }
      .bottom-info-wrapper {
        display: flex;
        align-items: center;
        .info-avatar {
          width: vw(56);
          height: vw(56);
          border-radius: 50%;
          object-fit: cover;
          margin-right: vw(16);
        }
        .info-desc {
          font-size: vw(13);
          font-weight: 500;
          color: #373d52;
          line-height: vw(21);
          flex: 1;
        }
      }
    }
  }

  .result-bottom-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    margin-top: vw(10);
  }

  .bottom-logo {
    padding: vw(20) 0 vw(27);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: vw(94);
      height: auto;
    }
  }

  .scroll-div {
    visibility: hidden;
    position: relative;
    top: vw(-70);
  }
}
</style>
